import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/user/customer.user.query.gql"
import type {
  CustomerUserQuery,
  CustomerUserQueryVariables,
} from "@/v2-backoffice-client/customer/user/__types__/customer.user.query"

type Options = QueryHookOptions<CustomerUserQuery, CustomerUserQueryVariables>

export function useCustomerUserQuery(options?: Options) {
  return useQuery<CustomerUserQuery, CustomerUserQueryVariables>(query, options)
}
